import React from "react";
import "./jackpot-banner.scss";
import Modal from "react-modal";
import JackpotBannerContent from "./jackpotWinBannerDesktop";

export default function JackpotBanner({ isOpen, jackpot, closeModal }) {
  return (
    <Modal
      ariaHideApp={false}
      className={"jackpot-banner-modal"}
      isOpen={isOpen}
      shouldFocusAfterRender={false}>
      <JackpotBannerContent
        amount={jackpot?.amount}
        currency={jackpot?.currency}
        tier={jackpot?.type?.toLocaleLowerCase()}
        onClick={closeModal}
      />
    </Modal>
  );
}
